import React from 'react'
import { SvgIcon } from '@mui/material'

export const PlusIcon = props => (
  <SvgIcon viewBox="0 0 34 34" sx={{ color: 'semiLightGray' }} {...props}>
    <path
      d="M26.917 15.583h-8.5v-8.5a1.417 1.417 0 0 0-2.833 0v8.5h-8.5a1.417 1.417 0 1 0 0 2.833h8.5v8.5a1.416 1.416 0 1 0 2.833 0v-8.5h8.5a1.417 1.417 0 1 0 0-2.833z"
      fill="inherit"
    />
  </SvgIcon>
)
